import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  // baseURL: "http://localhost:3001/api/",
});

instance.defaults.headers.common[
  "Authorization"
] = `Bearer ${sessionStorage.getItem("access_token")}`;

export default instance;
